import { render, staticRenderFns } from "./SouthKorea.vue?vue&type=template&id=2e23c926&"
import script from "./SouthKorea.vue?vue&type=script&lang=js&"
export * from "./SouthKorea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e23c926')) {
      api.createRecord('2e23c926', component.options)
    } else {
      api.reload('2e23c926', component.options)
    }
    module.hot.accept("./SouthKorea.vue?vue&type=template&id=2e23c926&", function () {
      api.rerender('2e23c926', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/countries/SouthKorea.vue"
export default component.exports